import { Checkbox, FormControlLabel } from "@mui/material";
import { useAllContext } from "../../context";
import XButton from "../../components/x-button";

export default function Filters() {
  const { filters, setFilters, onClose, fetchPost } = useAllContext();
  return (
    <div className="flex flex-col gap-4 items-center justify-center">
      <div className="flex flex-col w-full items-start justify-center">
        <label>Status</label>
        <FormControlLabel
          control={
            <Checkbox
              onChange={(ev) =>
                setFilters((prev) => ({
                  ...prev,
                  status: 1,
                }))
              }
              checked={filters?.status === 1 && true}
            />
          }
          label="Todos"
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={(ev) =>
                setFilters((prev) => ({
                  ...prev,
                  status: 2,
                }))
              }
              checked={filters?.status === 2 && true}
            />
          }
          label="Em aberto"
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={(ev) =>
                setFilters((prev) => ({
                  ...prev,
                  status: 3,
                }))
              }
              checked={filters?.status === 3 && true}
            />
          }
          label="Resolvido"
        />
      </div>
      <div className="flex flex-col w-full items-start justify-center">
        <label>Data</label>
        <FormControlLabel
          control={
            <Checkbox
              onChange={(ev) =>
                setFilters((prev) => ({
                  ...prev,
                  data: 1,
                }))
              }
              checked={filters?.data === 1 && true}
            />
          }
          label="Período Todo"
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={(ev) =>
                setFilters((prev) => ({
                  ...prev,
                  data: 2,
                }))
              }
              checked={filters?.data === 2 && true}
            />
          }
          label="Ano"
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={(ev) =>
                setFilters((prev) => ({
                  ...prev,
                  data: 3,
                }))
              }
              checked={filters?.data === 3 && true}
            />
          }
          label="Mês"
        />
        <FormControlLabel
          control={
            <Checkbox
              onChange={(ev) =>
                setFilters((prev) => ({
                  ...prev,
                  data: 4,
                }))
              }
              checked={filters?.data === 4 && true}
            />
          }
          label="Dia"
        />
      </div>

      <XButton
        name="Aplicar Filtros"
        onClick={() => {
          fetchPost({
            getCache: true,
          });
          onClose();
        }}
      />
    </div>
  );
}
